<template>
  <div class="background">
    <CookiesPrivacy />
    <router-view />
    <GlobalError />
    <LoginModal />
    <LoaderOverlay :active="uiStore.loading" />
  </div>
</template>

<script setup lang="ts">
import CookiesPrivacy from "@/components/cookies/cookiesPrivacy.vue";
import LoaderOverlay from "@/components/loader/loader.vue";
import GlobalError from "@/components/globalError/GlobalError.vue";
import LoginModal from "@/components/auth/LoginModal.vue";
import { useUIStore } from "@/stores/useUIStore";

const uiStore = useUIStore();
</script>
